import React, { useState, useEffect } from "react";
import { Modal, Input, Form, Row, Col, Typography, Select, message } from "antd";
import { platformApi } from "../../../../api";

const { Item } = Form;
const { Text, Title } = Typography;
const { Option } = Select;

const StateForm = (props) => {
  const [loading, setLoading] = useState(false);
  const [editable, setEditable] = useState(props.editable);
  const [countries, setCountries] = useState([]);

  const { form, open, close, data, modify, emitData } = props;
  const { getFieldDecorator, setFieldsValue, resetFields, validateFields } = form;

  useEffect(() => {
    setEditable(props.editable);
    if (data) {
      setFieldsValue({
        name: data.name,
        code: data.code,
        country: data.country || (data.Country ? data.Country.id : undefined),
      });
    }
  }, [data, props.editable]);

  useEffect(() => {
    if (open) {
      fetchCountries();
    }
  }, [open]);

  const fetchCountries = () => {
    platformApi
      .get("/api/csc/country")
      .then((res) => {
        if (res.data && res.data.code === 200) {
          setCountries(res.data.data || []);
        }
      })
      .catch((err) => {
        console.error("Error fetching countries for State form:", err);
        message.error("Failed to load countries");
      });
  };

  const handleSubmit = () => {
    validateFields((err, values) => {
      if (!err) {
        setLoading(true);
        const payload = {
          name: values.name.trim(),
          code: values.code.trim(),
          country: values.country,
        };
        if (data && data.id) {
          payload.id = data.id;
        }
        emitData(payload);
        setLoading(false);
        resetFields();
        close();
      }
    });
  };

  return (
    <Modal
      title={<Title level={4}>{data && data.id ? "Edit State" : "Add State"}</Title>}
      visible={open}
      okText={editable ? "Save" : "Modify"}
      onCancel={() => {
        resetFields();
        close();
      }}
      okButtonProps={{ loading, disabled: !modify && !editable }}
      onOk={() => (editable ? handleSubmit() : setEditable(true))}
    >
      <Form layout="vertical">
        <Row type="flex" justify="space-between">
          <Col span={24}>
            <Item label={<Text strong>Country</Text>} colon={false} required>
              {getFieldDecorator("country", {
                rules: [{ required: true, message: "Please select country!" }],
              })(
                <Select
                  disabled={!editable}
                  placeholder="Select Country"
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) => {
                    const label = Array.isArray(option.props.children)
                      ? option.props.children.join("")
                      : String(option.props.children || "");
                    return label.toLowerCase().indexOf(input.toLowerCase()) >= 0;
                  }}
                >
                  {countries.map((c) => (
                    <Option key={c.id} value={c.id}>
                      {c.name}
                    </Option>
                  ))}
                </Select>
              )}
            </Item>
          </Col>
        </Row>

        <Row type="flex" justify="space-between">
          <Col span={24}>
            <Item label={<Text strong>State Name</Text>} colon={false} required>
              {getFieldDecorator("name", {
                rules: [{ required: true, message: "Please enter state name!" }],
              })(
                <Input
                  disabled={!editable}
                  placeholder="Enter State Name (e.g. Tamil Nadu)"
                  maxLength={100}
                />
              )}
            </Item>
          </Col>
        </Row>

        <Row type="flex" justify="space-between">
          <Col span={24}>
            <Item label={<Text strong>State Code</Text>} colon={false} required>
              {getFieldDecorator("code", {
                rules: [{ required: true, message: "Please enter state code!" }],
              })(
                <Input
                  disabled={!editable}
                  placeholder="Enter State Code (e.g. TN)"
                  maxLength={20}
                />
              )}
            </Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

const WrappedStateModal = Form.create({ name: "state_form" })(StateForm);

export default WrappedStateModal;
